<template>
  <div class="empty-content">
    <img class="img-content" src="@/assets/images/website/home/nodata.png" />
    <p class="text-content">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '暂无数据～'
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
}
</script>
<style lang='less'>
.empty-content {
  width: 100%;
  background: #EDF1F3;
  text-align: center;
  padding: 180px 0;
  margin-top: 20px;

  .img-content {
    width: 110px;
    height: 110px;
  }

  .text-content {
    font-size: 14px;
    font-weight: bold;
    color: #BFC7D1;
  }
}
</style>
